// extracted by mini-css-extract-plugin
export default {"productHow":"ProductsHow_productHow__jTWgh","how":"ProductsHow_how__ir4KZ"};